import { Checklist } from "@bokio/designsystem/components/Checklist/Checklist";

import type { FC, ReactNode } from "react";

export type PromotionModalChecklistItem = ReactNode | string;
export interface PromotionModalChecklistProps {
	list: PromotionModalChecklistItem[];
}

export const PromotionModalChecklist: FC<PromotionModalChecklistProps> = props => {
	return props.list?.length ? <Checklist list={props.list} /> : null;
};
